module.exports = __webpack_public_path__ + "static/spokoj_og-8b3d9ee39b4560a708d71bd8da25d516.jpeg";